import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { CRITERIA_SELECTORS } from 'Views/booking/constants';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  departure?: string | null | undefined;
  transportIcon: IconName;
};
export const TransportSummary = ({ className, departure, transportIcon }: Props) => {
  const noTransportIcon = ICONS.NO_TRANSPORT;
  return (
    <div
      className={classnames('flex items-center gap-10 text-14', className)}
      data-testid={CRITERIA_SELECTORS.TRANSPORT}
    >
      <Icon
        className="shrink-0 text-sienna"
        hasRtl
        name={departure ? transportIcon : noTransportIcon}
        width="1.875rem"
      />
      {departure ? (
        <Fragment>
          {t('common.transport.from')} <span className="font-bold text-sienna">{departure}</span>
        </Fragment>
      ) : (
        t('booking.priceDetails.packagePrice.noTransport')
      )}
    </div>
  );
};
